import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="comparador-ver-mas"
//
// «Ver más» de los comparadores de seguros en móvil: trae la página siguiente y añade sus tarjetas
// al listado, sin salir de la página. El botón es un enlace de verdad a `?page=N` con los filtros
// puestos, así que sin JavaScript, o para un buscador, funciona como la paginación de siempre. Si
// la petición falla, también: se sigue el enlace.
export default class extends Controller {
  static targets = ['enlace']

  async cargar (event) {
    event.preventDefault()
    if (this.element.hasAttribute('aria-busy')) return

    const enlace = this.enlaceTarget
    this.element.setAttribute('aria-busy', 'true')
    try {
      // Con la cabecera del frame, Rails se ahorra el <head> de la página (`application_turbo`).
      const respuesta = await fetch(enlace.href, { headers: { 'Turbo-Frame': 'product-comparer' } })
      if (!respuesta.ok) throw new Error(`HTTP ${respuesta.status}`)

      const pagina = new DOMParser().parseFromString(await respuesta.text(), 'text/html')
      this.listado.append(...pagina.querySelectorAll('.rnk-ProductComparer_Items > *'))

      const siguiente = pagina.querySelector('[data-comparador-ver-mas-target="enlace"]')
      if (siguiente) {
        enlace.href = siguiente.href
      } else {
        this.element.remove()
      }
    } catch {
      window.location.href = enlace.href
    } finally {
      this.element.removeAttribute('aria-busy')
    }
  }

  get listado () {
    return this.element.closest('.rnk-ProductComparer').querySelector('.rnk-ProductComparer_Items')
  }
}
